<template>
    <div class="brt-classify-container">
        <div class="brt-cc-head"> <!--$router.replace($BRT.lastRoute)-->
            <div class="back" @click="back">
                <i class="iconfont icon-left-01"></i>
            </div>
            <div class="title">
                {{ titleSoure }}
            </div>
            <div class="right" @click="$router.replace('/search')">
                <i class="iconfont icon-search"></i>
            </div>
        </div>

        <div class="brt-cc-select">
            <ColSelect :data="ColSelectData" @on-select="onColSelect"></ColSelect>
        </div>

        <div class="brt-cc-body">
            <ul v-if="resultList.length">
                <li v-for="(item,index) in resultList" @click="seleted(item)">
                    <div class="pic">
                        <img v-if="item.detail && item.detail.LOGO" :src="item.detail.LOGO" alt="">
                        <img v-else :src="item.CATEGORY_ICON" alt="">
                        <!--<i v-else :class="'icon poi-icon-' + item.CATEGORY_ID"></i>-->
                    </div>
                    <div class="content">
                        <div>{{ item.NAME }}</div>
                        <div class="t2" v-if="item.CATEGORY_NAME">
                            {{ item.CATEGORY_NAME }}
                            <i></i>
                            {{ item.FLOOR_NAME }}
                        </div>
                        <Tags class="t3" v-if="item.activity || item.detail || item.theme_activity" :data="item" scroll></Tags>
                    </div>
                </li>
            </ul>

            <div class="none-box" v-else>
                <i></i>
                <span>未找到结果</span>
            </div>

            <FooterLine><!--我是有底线的--></FooterLine>
        </div>

    </div>
</template>

<script>
    import {Tags} from '@/components/tags'
    import {FooterLine} from '@/components/footerLine'
    import {ColSelect} from '@/modules/colSelect'

    import {_activityPoiExtend, _detailPoiExtend,CATEGORY_ICONExtend,_themeActivityPoiExtend} from "@/utils/search_poi_extend";

    export default {
        name: "Classify",
        components: {
            Tags,
            FooterLine,
            ColSelect
        },

        data() {
            return {
                //所有poi数据缓存
                resultCache: [],
                //需ui展示的poi数据
                resultList: [],
                //定制列选择条件数据
                ColSelectData: [],

                titleSoure:this.title
            }
        },

        props: {
            title: {
                type:String,
                default: '品牌列表'
            }
        },

        created(){

            this.titleSoure = JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).searchRightTitle ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).searchRightTitle:'品牌列表'

        },

        methods: {
            onColSelect(res) {

                let floorItem = res[0],
                    classItem = res[1],
                    activityItem = res[2];

                //楼层筛选
                this.resultList = this.resultCache.filter((item) => {
                    if (floorItem.value === 'F-all') {
                        return true
                    }
                    else {
                        return item.FLOOR_ID === floorItem.value;
                    }
                });


                //分类筛选
                this.resultList = this.resultList.filter((item) => {
                    if (classItem.value === 'C-all') {
                        return true;
                    }
                    else {
                        if (classItem.value.length >= 6) {
                            return classItem.value === item.CATEGORY_ID;
                        }
                        else {
                            return classItem.value === item.CATEGORY_ID.substr(0, 4);
                        }
                    }
                });


                //活动筛选
                this.resultList = this.resultList.filter((item) => {
                    if (activityItem.value === 'P-all') {
                        return true;
                    }
                    else if (activityItem.value === 'activity') {
                        return !!item.activity || item.theme_activity.length
                    }
                    else {
                        return !item.activity
                    }
                });

            },

            seleted(item){

                this.$router.replace('/map');

                this.$BRT.$filter.open = true;
                this.$BRT.$filter.initEnter = 'classify';

                this.$message.load(true);

                this.$mapStep.poiID = item.POI_ID;
                this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                this.$mapStep.type = 'selectePOI';

            },

            back(){

                if(this.$BRT.lastRoute == '/map'){

                    this.$router.replace('/map');

                }else{

                    this.$router.replace('/search');

                }
            }
        },

        mounted() {

            let floorArray = [
                    {
                        label: '全部楼层',
                        value: 'F-all'
                    }
                ],
                classifyArray = [
                    {
                        label: '全部分类',
                        value: 'C-all',
                        children: [
                            {
                                label: '全部',
                                value: 'CA-all'
                            }
                        ]
                    }
                ],
                activityArray = [
                    {
                        label: '全部服务',
                        value: 'P-all'
                    },
                    {
                        label: '只看有活动',
                        value: 'activity'
                    }
                ];

            // init select data
            this.ColSelectData = [floorArray, classifyArray, activityArray];

            // init floor array
            function initFloorArray(array) {
                array.map(item => {
                    floorArray.push({
                        label: item.floorName,
                        value: item.mapID,
                        f_number: item.floorNumber
                    });
                });
            }

            if ($VAR.map.mapInfoArray) {
                initFloorArray($VAR.map.mapInfoArray);
            }
            else {
                $VAR.map.on('mapready', () => {
                    initFloorArray($VAR.map.mapInfoArray);
                });
            }

            let callee = ()=>{

                //实例化搜索功能
                let brtmapSearch = $VAR.brtmapSearch;

                // init classify array
                let _search_callee = typeCache => {

                    let array = JSON.parse(JSON.stringify(typeCache)), searchArray = [];
                    // console.log('typeCache', array);
                    array.map(item => {
                        //排除 00:辅助设施   11:交通服务   15:通行设施    16:公共设施 大类
                        if (['00', '11', '15', '16'].indexOf(item.value) === -1) {

                            item.children.map(child => {

                                    //格式化搜索缓存数据
                                    if (child.children[0] && child.children[0].value.indexOf('all') === -1) {

                                        child.children.map(child2 => {
                                            brtmapSearch.query({
                                                type: 'cid',
                                                value: child2.value
                                            }, res => {

                                                //排除不可用数据
                                                res = res.filter(item=>{
                                                    let isTrue = true;
                                                    if(item.CATEGORY_ID.length >= 4 && Math.round(item.CATEGORY_ID) < 1200)isTrue = false;

                                                    //排除门、大类、不满足的数据
                                                    return isTrue;
                                                });

                                                //检查是否有详情poi
                                                res = _detailPoiExtend(res, this.$store.state.POI_DETAIL_DATA);
                                                //检查是否有活动poi
                                                res = _activityPoiExtend(res, this.$store.state.ACTIVITY_DATA);
                                                //检查是否有主题活动
                                                res = _themeActivityPoiExtend(res,this.$store.state.THEME_ACTIVITY_DATA[0])
                                                //类型图标
                                                res = CATEGORY_ICONExtend(res);

                                                searchArray = searchArray.concat(res);
                                            });
                                        });

                                        child.children.unshift({
                                            label: '全部',
                                            value: child.value + '-all'
                                        });

                                        //格式化分类筛选
                                        classifyArray.push(child);
                                    }

                            });

                        }
                    });

                    //缓存需筛选的poi数据
                    searchArray.sort((a, b) => {
                        return a.FLOOR_NUMBER - b.FLOOR_NUMBER;
                    });
                    searchArray.sort((a, b) => {
                        return !!a.activity;
                    });

                    //排除无name的数据
                    searchArray = searchArray.filter(item=>{
                        return !!item.NAME;
                    })


                    this.resultCache = searchArray.concat();
                    this.resultList = searchArray.concat();
                };


                if (brtmapSearch._poiTypeCache) {

                    if(!this.$mapEventManger.brandReadyStatus){

                        this.$mapEventManger.brandReadyEvents.push(()=>{
                            _search_callee(brtmapSearch._poiTypeCache)
                        })

                    }else{
                        //是否存在poi分类缓存
                        _search_callee(brtmapSearch._poiTypeCache);
                    }

                }

                else{

                    brtmapSearch.on('ready', () => {

                        if(!this.$mapEventManger.brandReadyStatus){
                            this.$mapEventManger.brandReadyEvents.push(()=>{
                                _search_callee(brtmapSearch._poiTypeCache)
                            })
                        }else{
                            //是否存在poi分类缓存
                            _search_callee(brtmapSearch._poiTypeCache);
                        }

                    });
                }
            }

            if(!this.$mapEventManger.mapQueryStatus){
                this.$mapEventManger.mapQueryEvents.push(callee)
            }else{
                callee && callee();
            }
        }
    }
</script>

<style lang="less">

    @import "../../styles/cssBlock.less";

    .brt-classify-container {
        display: flex;
        flex-direction: column;

        > .brt-cc-head {
            @height: @95px;

            display: flex;
            background-color: #FFFFFF;
            box-shadow: 0 0 @3px @fontColorA4;
            height: @height;

            > .back {
                width: @height;
                height: @height;
                line-height: @height;
                text-align: center;

                &:active {
                    background-color: @activeBgColorA2;
                }

                > .iconfont {
                    font-size: @40px;
                    color: @fontColorA2;
                }
            }

            > .title {
                flex: 1;
                text-align: center;
                font-size: @32px;
                line-height: @height;
                color: @fontColorA1;
            }

            > .right {
                width: @height;
                line-height: @height;
                text-align: center;

                &:active {
                    background-color: @activeBgColorA2;
                }

                > .iconfont {
                    font-size: @38px;
                    color: @fontColorA2;
                }
            }

        }

        > .brt-cc-select {
            border-top: 1px solid @borderColorA2;
            border-bottom: 1px solid @borderColorA2;
        }

        > .brt-cc-body {
            flex: 1;
            overflow-y: auto;

            &::-webkit-scrollbar{
                display: none;
                width: 0px;
            }

            -webkit-overflow-scrolling: touch;

            > ul {
                padding: 0 @spacingNumber;
                background-color: #FFFFFF;

                > li {
                    display: flex;
                    padding: @spacingNumber 0;
                    border-bottom: 1px solid @borderColorA2;
                    align-items: center;

                    > .pic {
                        width: @155px;
                        height: @155px;
                       // background-color: fade(@fontColorA4,80%);
                        border: 1px solid @borderColorA2;
                        text-align: center;
                        line-height:@155px;
                        > img {
                            width: 80%;
                            height: 80%;
                            vertical-align: middle;
                            opacity: .8;
                        }

                        > .icon {
                            display: inline-block;
                            width: 100%;
                            height: 100%;
                            background: center no-repeat;
                            background-size: 60% auto;
                        }
                    }

                    > .content {
                        flex: 1;
                        padding: 0 @spacingNumber / 1.5;
                        min-width: 1px;

                        .t2 {
                            font-size: @23px;
                            margin-top: @10px;
                            color: @fontColorA3;

                            > i {
                                display: inline-block;
                                height: @15px;
                                border-right: 1px solid @fontColorA4;
                                margin: 0 @6px;
                            }
                        }

                        .t3 {
                            margin-top: @10px;
                        }
                    }
                }
            }

            .none-box {
                text-align: center;
                padding: @120px 0;
                color: @fontColorA3;
                font-size: @normalFontSize - @2px;
                background-color: #FFFFFF;

                > i {
                    display: inline-block;
                    width: @65px;
                    height: @74px;
                    background: url("../../../public/images/zanwu@2x.png") center no-repeat;
                    background-size: 100% auto;
                }

                > span {
                    display: block;
                }
            }
        }
    }

</style>
